import React, { useState } from "react";
import EscrowTitleFields from "./EscrowTitleFields";
import SellerClosingCosts from "./SellerClosingCosts";

export default function ClosingCostsSection({
  mainId,
  control,
  FloatingInput,
  FloatingNumber,
  CustomSelect,
  getValues,
  setValue,
  openModal,
  closeModal,
  cleanNumber,
  sellerClosingCostArray,
  totalClosingMeta,
  handleSellerCalculation,
}) {
  const [escrowDisabled, setEscrowDisabled] = useState({
    escrowSettlement: true,
    ownersPolicy: true,
    lendersPolicy: true,
    premiumText: "",
  });

  const getVal = (path, fallback = "") => {
    try {
      if (typeof getValues === "function") {
        const v = getValues(path);
        return v === undefined ? fallback : v;
      }
    } catch (e) {
      return fallback;
    }
    return fallback;
  };

  const handleEscrowContinue = (setting) => {
    const pstString = new Date().toLocaleString("en-US", {
      timeZone: "America/Los_Angeles",
    });
    const [pstDate, pstTimeFull] = pstString.split(", ");
    const pstTime =
      pstTimeFull?.split(":").slice(0, 2).join(":") +
      (pstTimeFull?.includes("AM") ? " AM" : " PM");
    const preparedBy = getVal("preparedBy", "");
    const premiumText = `*Premium changed ${preparedBy} ${pstDate} ${pstTime} PST`;

    setEscrowDisabled((prev) => ({ ...prev, ...setting, premiumText }));
    setValue("escrowPremiumChanged", true);

    const updates = {
      "titleSettlementMeta.premiumText": premiumText,
      ...(setting.escrowSettlement === false && {
        "titleSettlementMeta.escrowSettlement": false,
      }),
      ...(setting.ownersPolicy === false && {
        "titleSettlementMeta.ownersPolicy": false,
      }),
      ...(setting.lendersPolicy === false && {
        "titleSettlementMeta.lendersPolicy": false,
      }),
    };

    Object.entries(updates).forEach(([path, value]) => setValue(path, value));
    closeModal();
  };

  return (
    <>
      <h3 className="m-btm-16">Closing Costs</h3>

      <EscrowTitleFields
        mainId={mainId}
        control={control}
        FloatingInput={FloatingInput}
        FloatingNumber={FloatingNumber}
        CustomSelect={CustomSelect}
        cleanNumber={cleanNumber}
        getValues={getValues}
        setValue={setValue}
        EscrowDisabled={escrowDisabled}
        handleSellerCalculation={handleSellerCalculation}
        onContinue={handleEscrowContinue}
        openModal={openModal}
        closeModal={closeModal}
      />

      {sellerClosingCostArray?.fields?.length > 0 && (
        <SellerClosingCosts
          fields={sellerClosingCostArray.fields}
          control={control}
          FloatingInput={FloatingInput}
          cleanNumber={cleanNumber}
          parentName="sellerClosingCostMeta"
          salesPrice={getVal("salesPrice", "")}
          getValues={getValues}
          setValue={setValue}
        />
      )}

      {getVal("escrowPremiumChanged") && (
        <p className="premium-txt">{escrowDisabled.premiumText}</p>
      )}
    </>
  );
}
